<h1 i18n>About LangPro Annotator</h1>

<p i18n>
    LangPro Annotator is an online annotation tool developed at the Centre for
    Digital Humanities.
</p>

<p i18n><em>More information to follow!</em></p>
